package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.TimerW500Rounded: ImageVector
    get() {
        if (_timerW500Rounded != null) {
            return _timerW500Rounded!!
        }
        _timerW500Rounded = Builder(name = "TimerW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(396.17f, 120.0f)
                quadToRelative(-18.43f, 0.0f, -31.01f, -12.7f)
                quadToRelative(-12.57f, -12.69f, -12.57f, -31.13f)
                quadToRelative(0.0f, -18.43f, 12.57f, -31.01f)
                quadToRelative(12.58f, -12.57f, 31.01f, -12.57f)
                horizontalLineToRelative(167.66f)
                quadToRelative(18.43f, 0.0f, 31.01f, 12.57f)
                quadToRelative(12.57f, 12.58f, 12.57f, 31.01f)
                quadToRelative(0.0f, 18.44f, -12.57f, 31.13f)
                quadToRelative(-12.58f, 12.7f, -31.01f, 12.7f)
                lineTo(396.17f, 120.0f)
                close()
                moveTo(511.01f, 554.12f)
                quadToRelative(12.58f, -12.58f, 12.58f, -31.01f)
                verticalLineToRelative(-153.54f)
                quadToRelative(0.0f, -18.44f, -12.58f, -31.02f)
                quadToRelative(-12.58f, -12.57f, -31.01f, -12.57f)
                reflectiveQuadToRelative(-31.01f, 12.57f)
                quadToRelative(-12.58f, 12.58f, -12.58f, 31.02f)
                verticalLineToRelative(153.54f)
                quadToRelative(0.0f, 18.43f, 12.58f, 31.01f)
                quadTo(461.57f, 566.7f, 480.0f, 566.7f)
                reflectiveQuadToRelative(31.01f, -12.58f)
                close()
                moveTo(337.15f, 865.49f)
                quadToRelative(-66.93f, -29.1f, -117.01f, -79.05f)
                quadToRelative(-50.07f, -49.96f, -79.17f, -116.9f)
                quadToRelative(-29.1f, -66.93f, -29.1f, -142.84f)
                quadToRelative(0.0f, -75.92f, 29.1f, -142.85f)
                quadToRelative(29.1f, -66.94f, 79.17f, -117.01f)
                quadToRelative(50.08f, -50.08f, 117.01f, -79.18f)
                quadToRelative(66.94f, -29.09f, 142.85f, -29.09f)
                quadToRelative(62.48f, 0.0f, 120.43f, 20.0f)
                quadToRelative(57.96f, 20.0f, 108.2f, 58.23f)
                lineToRelative(28.24f, -28.23f)
                quadToRelative(12.43f, -12.44f, 30.75f, -12.44f)
                quadToRelative(18.31f, 0.0f, 30.75f, 12.44f)
                quadTo(810.8f, 221.0f, 810.8f, 239.32f)
                quadToRelative(0.0f, 18.31f, -12.43f, 30.75f)
                lineToRelative(-28.24f, 28.23f)
                quadToRelative(38.24f, 50.24f, 58.12f, 108.08f)
                quadToRelative(19.88f, 57.84f, 19.88f, 120.32f)
                quadToRelative(0.0f, 75.91f, -29.1f, 142.84f)
                quadToRelative(-29.1f, 66.94f, -79.17f, 116.9f)
                quadToRelative(-50.08f, 49.95f, -117.01f, 79.05f)
                quadToRelative(-66.94f, 29.1f, -142.85f, 29.1f)
                reflectiveQuadToRelative(-142.85f, -29.1f)
                close()
                moveTo(676.09f, 722.66f)
                quadToRelative(81.04f, -80.92f, 81.04f, -195.96f)
                quadToRelative(0.0f, -115.05f, -81.04f, -196.09f)
                quadToRelative(-81.05f, -81.04f, -196.09f, -81.04f)
                reflectiveQuadToRelative(-196.09f, 81.04f)
                quadToRelative(-81.04f, 81.04f, -81.04f, 196.09f)
                quadToRelative(0.0f, 115.04f, 81.04f, 195.96f)
                quadToRelative(81.05f, 80.93f, 196.09f, 80.93f)
                reflectiveQuadToRelative(196.09f, -80.93f)
                close()
                moveTo(480.0f, 526.7f)
                close()
            }
        }
        .build()
        return _timerW500Rounded!!
    }

private var _timerW500Rounded: ImageVector? = null
